import { langRef } from '@/utils/i18n';
import EnMap from './ApiMsgEn';
import ZhMap from './ApiMapMsgZh';

export const errMsg: Record<string, Record<string, string>> = {
    en: {
        "-1": "network error",
        "5": "fail to authenticate",
        ...EnMap,
    },
    zh: {
        "-1": "请检查网络连接",
        "5": "鉴权失败",
        ...ZhMap,
    },
};

export const localMsg: Record<string, Record<string, string>> = {
    en: {
        "OP_SUCCESS": "Operation successfully",
        "OP_FAILED": "Operation failed",
        "LOGIN_FAILED": "Login failed",
        "LOGIN_SUCCESS": "Login successfully",
        "LOGOUT_SUCCESS": "Logout success",
        "LOGOUT_FAILED": "Logout failed",
        "VERCODE_FAILED": "Failed to send verification code",
        "VERCODE_SUCCESS": "Verification code sent successfully",
        "LOCAL_DS_NOT_FOUND": "Local data-source not found",
        "SVC_NOT_AVAILABLE": "Service not available",
        "USERNAME_EMPTY": "Account info is empty",
        "PASSWORD_EMPTY": "Password is empty",
        "MOBILE_EMPTY": "Mobile is empty",
        "VERCODE_EMPTY": "Verification code is empty",
        "REDIRECT_LOGIN_PAGE": "redirecting to login page...",
        "RESET_PWD_ERR": "Reset password failed",
        "MOBILE_ALREADY_EXISTS": "Mobile already exists",
        "EMAIL_ALREADY_EXISTS": "Email already exists",
        "INVALID_RESET_PWD_METHOD": "Please select a challenge method to reset your password",
        "CAPTCHA_ERR": "Check captch failed",
    },
    zh: {
        "OP_SUCCESS": "操作成功",
        "OP_FAILED": "操作失败",
        "LOGIN_FAILED": "登录失败",
        "LOGIN_SUCCESS": "登录成功",
        "LOGOUT_SUCCESS": "登出成功",
        "LOGOUT_FAILED": "登出失败",
        "VERCODE_FAILED": "发送验证码失败",
        "VERCODE_SUCCESS": "发送验证码成功",
        "LOCAL_DS_NOT_FOUND": "本地数据源未找到",
        "SVC_NOT_AVAILABLE": "服务暂不可用",
        "USERNAME_EMPTY": "请输入账号信息",
        "PASSWORD_EMPTY": "请输入密码",
        "MOBILE_EMPTY": "请输入手机号",
        "VERCODE_EMPTY": "请输入验证码",
        "REDIRECT_LOGIN_PAGE": "正在跳转到登录页面...",
        "RESET_PWD_ERR": "重置密码失败",
        "MOBILE_ALREADY_EXISTS": "该手机号已存在",
        "EMAIL_ALREADY_EXISTS": "该邮箱已存在",
        "INVALID_RESET_PWD_METHOD": "请选择一种重置密码方式",
        "CAPTCHA_ERR": "校验失败",
    },
}

const ErrMsg = function (code: string, msg?: string): string {
    // code to int
    const idx = parseInt(code);
    if (idx >= 0x00067000 && idx < 0x00068000) {
        return msg ?? "";
    }
    return errMsg[langRef.value || 'zh'][code];
}

const LoMsg = function (code: string): string {
    return localMsg[langRef.value || 'zh'][code];
}

export {
    ErrMsg,
    LoMsg,
}
